import { localizedStrings } from "../../../common/localization/LocalizedStrings";
import * as Constants from "../../../common/Constants";

export function getLocale(): string {
    let interfaceLocale = localizedStrings.getInterfaceLanguage().toLowerCase();
    interfaceLocale = localizedStrings.getAvailableLanguages().includes(interfaceLocale) ? interfaceLocale : Constants.DefaultLocale;
    localizedStrings.setLanguage(interfaceLocale);
    return interfaceLocale;
}